import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";
interface UserProfileSettingsResponse {
  id: number;
  title: string;
  field_language_image: string;
  field_camera_en: string;
  field_camera_ms: string;
  field_camera_zh: string;
  field_change_pwd_en: string;
  field_change_pwd_ms: string;
  field_change_pwd_zh: string;
  field_favourite_text: string;
  field_favourite_text_ms: string;
  field_favourite_text_zh: string;
  field_generated_ms: string;
  field_generated_en: string;
  field_generated_zh: string;
  field_location_en: string;
  field_location_ms: string;
  field_location_zh: string;
  field_login_id_text_en: string;
  field_login_id_text_ms: string;
  field_login_id_text_zh: string;
  field_logout_en: string;
  field_logout_ms: string;
  field_logout_zh: string;
  field_notification_ms: string;
  field_notifications_en: string;
  field_notifications_zh: string;
  field_permission_en: string;
  field_permission_ms: string;
  field_permission_zh: string;
  field_progress_en: string;
  field_progress_ms: string;
  field_progress_zh: string;
  field_purchase_en: string;
  field_purchase_ms: string;
  field_purchase_zh: string;
  field_purchase_login_en: string;
  field_purchase_login_ms: string;
  field_purchase_login_zh: string;
  field_settings_zh: string;
  field_settings_en: string;
  field_settings_ms: string;
  field_updates_en: string;
  field_updates_ms: string;
  field_updates_zh: string;
  field_user_profile_en: string;
  field_user_profile_ms: string;
  field_user_profile_zh: string;
  field_version_en: string;
  field_version_ms: string;
  field_version_zh: string;
  field_profile_en: string;
  field_profile_ms: string;
  field_profile_zh: string;
  field_edit_profile_en: string;
  field_edit_profile_ms: string;
  field_edit_profile_zh: string;
  field_view_id_en: string;
  field_view_id_ms: string;
  field_view_id_zh: string;
  field_save_en: string;
  field_save_ms: string;
  field_save_zh: string;
  field_cancel_en: string;
  field_cancel_ms: string;
  field_cancel_zh: string;
  field_pwd_image: string;
  field_forward_image: string;
  field_edit_profile_image: string;
  field_delete_icon: string;
}

interface PurchaseQRResponse {
  id: number;
  title: string;
  field_login_id_purchase: string;
  field_login_purchase_ms: string;
  field_login_purchase_zh: string;
  field_payment_txt_en: string;
  field_payment_txt_ms: string;
  field_payment_txt_zh: string;
  field_confirm_txt_en: string;
  field_confirm_txt_ms: string;
  field_confirm_txt_zh: string;
  field_account_details_en: string;
  field_account_details_ms: string;
  field_account_details_zh: string;
  field_bank_name_en: string;
  field_bank_name_ms: string;
  field_bank_name_zh: string;
  field_account_no_en: string;
  field_account_no_ms: string;
  field_account_no_zh: string;
  field_name_en: string;
  field_name_ms: string;
  field_name_zh: string;
  field_total_pay_amt_en: string;
  field_total_pay_amt_ms: string;
  field_total_pay_amt_zh: string;
  field_scan_txt_en: string;
  field_scan_txt_ms: string;
  field_scan_txt_zh: string;
  field_upload_txt_en: string;
  field_upload_txt_ms: string;
  field_upload_txt_zh: string;
  field_choose_en: string;
  field_choose_ms: string;
  field_choose_zh: string;
  field_format_en: string;
  field_format_ms: string;
  field_format_zh: string;
}

interface PurchaseSuccessResponse {
  id: number;
  field_success_image: string;
  field_payment_approved_en: string;
  field_payment_approved_ms: string;
  field_payment_approved_zh: string;
  field_login_id_success_en: string;
  field_login_id_success_ms: string;
  field_login_id_success_zh: string;
  field_id_status_en: string;
  field_id_status_ms: string;
  field_id_status_zh: string;
  field_user_id_en: string;
  field_user_id_ms: string;
  field_user_id_zh: string;
  field_pwd_en: string;
  field_pwd_ms: string;
  field_pwd_zh: string;
  field_support_en: string;
  field_support_ms: string;
  field_support_zh: string;
  field_support_email: string;
  field_support_email_ms: string;
  field_support_email_zh: string;
  field_bhrs_en: string;
  field_bhrs_ms: string;
  field_bhrs_zh: string;
  field_ok_en: string;
  field_ok_ms: string;
  field_ok_zh: string;
  field_approve_en: string;
  field_approve_ms: string;
  field_approve_zh: string;
}

const useUserProfileSettings = (
  options?: UseQueryOptions<UserProfileSettingsResponse[], DefaultError, UserProfileSettingsResponse[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<UserProfileSettingsResponse[], DefaultError> => {
  return useQuery<UserProfileSettingsResponse[], DefaultError, UserProfileSettingsResponse[], QueryKey>(
    {
      queryKey: ["userProfileSettings"],
      enabled: false,
      queryFn: async (): Promise<UserProfileSettingsResponse[]> => {
        const response = await magpCMSApi.get<UserProfileSettingsResponse[]>(`/api/get-user-profile/all-fields`);

        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const usePurchaseQR = (
  options?: UseQueryOptions<PurchaseQRResponse[], DefaultError, PurchaseQRResponse[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PurchaseQRResponse[], DefaultError> => {
  return useQuery<PurchaseQRResponse[], DefaultError, PurchaseQRResponse[], QueryKey>(
    {
      queryKey: ["purchaseQR"],
      enabled: false,
      queryFn: async (): Promise<PurchaseQRResponse[]> => {
        const response = await magpCMSApi.get<PurchaseQRResponse[]>(`/api/get-purhcase-qr/all-fields`);

        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const usePurchaseSuccess = (
  options?: UseQueryOptions<PurchaseSuccessResponse[], DefaultError, PurchaseSuccessResponse[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PurchaseSuccessResponse[], DefaultError> => {
  return useQuery<PurchaseSuccessResponse[], DefaultError, PurchaseSuccessResponse[], QueryKey>(
    {
      queryKey: ["purchaseSuccess"],
      enabled: false,
      queryFn: async (): Promise<PurchaseSuccessResponse[]> => {
        const response = await magpCMSApi.get<PurchaseSuccessResponse[]>(`/api/get-purchase-success/all-fields`);

        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePurchaseQR, usePurchaseSuccess, useUserProfileSettings };
